<template>
	<div class="container-fluid">
		<div class="container">
			<div class="logo-container" v-if="!isLoginPortal && !isForgotPasswordPortal">
				<div class="row">
					<div class="logo d-flex justify-content-center">
						<router-link to="/home" title="Home">
							<img class="logo-img" src="../assets/image/logo.png">
							<img src="../assets/image/bar.png" style="height: 42px;">
						</router-link>
						
						<span class="fs-4 page-header-title logo-text">BERJAYA FINANCE - RPK</span>
						<span class="fs-4 page-header-title logo-text text-danger" v-if="envMode != null && envMode != ''">&nbsp;[{{envMode}}]</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { envMode } from "../../package.json";
	
	import { useRoute } from "vue-router"
	
	export default defineComponent({
		data() {
            return {
				envMode: envMode,
			}
		},
		computed: {
			isLoginPortal() { return useRoute().fullPath.startsWith("/login") },
			isForgotPasswordPortal() { return useRoute().fullPath.startsWith("/forgotpassword") }
		}
	});
</script>